module.exports = __webpack_public_path__ + "ba3a5b99.png";